import Layout from '@components/layout/Main'
import Post from '@components/blog/pages/Post'
import Seo from 'src/seo/components/Seo'
import JsonLdBlogArticle from 'src/seo/jsonld/JsonLdBlogArticle'

import dbConnect from 'db/dbConnect'
import blogRepo from 'db/repo/blog'
import usePageSeoWithArticleParams from 'src/seo/server/usePageSeoWithArticleParams'
import videoValidation from '@components/form/validation/field/wideo'
import splitOffersViaAdType from '@utils/offers/splitOffersViaAdType'

const videoRegexp = videoValidation.pattern.value

export default function BlogMainPage ({ article, connectedAds,
    prevArticle, nextArticle, similar, seo }) {

    return (
        <Layout>
            <Seo seo={seo} />
            <JsonLdBlogArticle article={article} />
            <Post
                article={article}
                connectedAds={connectedAds}
                prevArticle={prevArticle}
                nextArticle={nextArticle}
                similar={similar} />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const { article, connectedAds, prevArticle, nextArticle, similar } =
        await blogRepo.getFullArticle(context.query)

    // TODO: cache

    return article
        ? { props: {
                article: parseVideos(article),
                connectedAds: splitOffersViaAdType(connectedAds),
                prevArticle,
                nextArticle,
                similar,
                seo: await usePageSeoWithArticleParams({
                    pageId: 'blog-wpis',
                    article,
                })}}

        : { redirect:{
            permanent: false,
            destination: '/404' }}
}

function parseVideos (item) {
    const { topContent, bottomContent } = item
    if (topContent) item.topContent = embedKnownVideoLinksInIframe(topContent)
    if (bottomContent) item.bottomContent = embedKnownVideoLinksInIframe(bottomContent)

    return item
}

const START_TAG = '<oembed url="'
const END_TAG = '"></oembed>'
function embedKnownVideoLinksInIframe (text, fromIdx = 0) {
    if (fromIdx >= text.length) return text

    const startIdx = text.indexOf(START_TAG, fromIdx)
    const startExists = startIdx !== -1
    const endIdx = startExists && text.indexOf(END_TAG, startIdx + START_TAG.length)
    const endExists = startExists && endIdx !== -1
    if (startExists && endExists) {
        const urlStartIdx = startIdx + START_TAG.length
        const url = text.slice(urlStartIdx, endIdx)
        const knownFormat = videoRegexp.test(url)

        if (knownFormat) {
            const video = url.replace('watch?v=', 'embed/')
            const html = `<div style="padding-top:56.25%;position:relative;overflow:hidden;width:100%;"><iframe
                width="100%"
                height="100%"
                src="${video}"
                style="inset:0;position:absolute;"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe></div>`
            const finalIdx = endIdx + END_TAG.length
            const newText = `${text.slice(0, startIdx)}${html}${text.slice(finalIdx)}`
            return embedKnownVideoLinksInIframe(newText, startIdx + html.length)
        }

    } else {
        return text
    }
}